/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getCurrentUserIsGuest, getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PetForm from "@rc/App/Components/MyPets/PetForm";
import getMyPetsData from "@rc/App/Handlers/MyPets/getMyPets";
import { CustomAppState } from "@rc/App/Store/Reducers";
import React from "react";
import { connect, ResolveThunks, useDispatch } from "react-redux";

const enum fields {}

interface OwnProps extends WidgetProps {
    fields: {};
}

const mapStateToProps = (state: CustomAppState) => {
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    const userName = state.context.session.userName;
    const { species } = getQueryStrings(state);

    return {
        isAuthenticated: userName && !currentUserIsGuest,
        species,
    };
};

const mapDispatchToProps = {
    getMyPetsData,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AddPetStyles {
    container?: InjectableCss;
}

export const addPetStyles: AddPetStyles = {};

const AddPet = ({ isAuthenticated, species }: Props) => {
    const styles = addPetStyles;

    if (!isAuthenticated) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <Typography variant="h1" transform="capitalize">
                {translate("add a")}&nbsp;{species}
            </Typography>
            <PetForm type={species as "cat" | "dog"} mode="add"></PetForm>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AddPet),
    definition: {
        group: "XNGAGE" as any,
        fieldDefinitions: [],
        allowedContexts: ["MyPetAddPetPage", "MyPetsPage"],
    },
};

export default widgetModule;
